import React from 'react'
import "../CSS/Project.css"
import Button from '@material-ui/core/Button';
const Project = () => {
    return (
       
       <>  
           <div className ="backProject">
               <div className="container">
                   <div className="col-10 mx-auto">
                       <div className="headerProject">
                           <h1>Projects</h1>
                       </div>
                       <div className="dProject">
                           <h3>1.Breaking Bad Cast Feature</h3>
                           <Button className="btn" variant="contained" color="primary">
                            Visit us
                           </Button>
                        
                       </div>
                    </div>
               </div>
           </div>
        
       </>
    )
}

export default Project

